export const PRICE_POLICY_CONTENT_KEY = 'price-policy-content';
